import breakpoints, {BreakpointName} from '../constants/breakpoints';

export const isMobileBreakpoint = (breakpoint: BreakpointName): boolean =>
    [breakpoints.name.XSMALL, breakpoints.name.SMALL].includes(breakpoint);

export const isTabletBreakpoint = (breakpoint: BreakpointName): boolean =>
    [breakpoints.name.MEDIUM].includes(breakpoint);

export const isLargeBreakpoint = (breakpoint: BreakpointName): boolean =>
    [breakpoints.name.LARGE].includes(breakpoint);

export const isExtraLargeBreakpoint = (breakpoint: BreakpointName): boolean =>
    [breakpoints.name.XLARGE].includes(breakpoint);

export const isDesktopBreakpoint = (breakpoint: BreakpointName): boolean =>
    [breakpoints.name.LARGE, breakpoints.name.XLARGE, breakpoints.name.MAX].includes(breakpoint);

export const isTabletOrLarge = (breakpoint: BreakpointName): boolean =>
    [breakpoints.name.MEDIUM, breakpoints.name.LARGE].includes(breakpoint);

export const isExtraLargeOrGreater = (breakpoint: BreakpointName): boolean =>
    [breakpoints.name.XLARGE, breakpoints.name.MAX].includes(breakpoint);

export const isMaxBreakpoint = (breakpoint: BreakpointName): boolean =>
    [breakpoints.name.MAX].includes(breakpoint);
